module.exports = __webpack_public_path__ + "img/38.1a89c2c.webp";